module.exports = __webpack_public_path__ + "static/media/logo-new.75887bc9.svg";